import { BaseDataResponseBody, EmployeePrivilegesProfiles } from "../types";

export const isTrustpilotEmployee = (
  employeePrivileges: BaseDataResponseBody["businessUser"]["privileges"],
  businessUserEmail = "",
): boolean => {
  if (!businessUserEmail.endsWith("@trustpilot.com")) {
    return false;
  }
  if (employeePrivileges === null) {
    // privileges initialized only for employees
    return false;
  }

  return true;
};

const hasOnlyOverviewPrivilege = (employeePrivileges: BaseDataResponseBody["businessUser"]["privileges"]): boolean => {
  if (employeePrivileges.length === 0) {
    return true;
  }

  if (
    employeePrivileges.length === 1 &&
    employeePrivileges.indexOf(EmployeePrivilegesProfiles.OVERVIEWPRIVILEGE) !== -1
  ) {
    return true;
  }

  return false;
};

const hasEditPrivilege = (employeePrivileges: BaseDataResponseBody["businessUser"]["privileges"]): boolean => {
  if (employeePrivileges.indexOf(EmployeePrivilegesProfiles.EDITPRIVILEGE) > -1) {
    return true;
  }
  return false;
};

const hasElevatedEditPrivilege = (
  employeePrivileges: BaseDataResponseBody["businessUser"]["privileges"],
  businessUserEmail: string,
): boolean => {
  if (!isTrustpilotEmployee(employeePrivileges, businessUserEmail)) {
    return true;
  }

  if (employeePrivileges.indexOf(EmployeePrivilegesProfiles.ELEVATEDPRIVILEGE) > -1) {
    return true;
  }
  return false;
};

/**
 * Returns true/false whether consents indicator in business unit should be displayed or not.
 */
export const showBusinessUnitConsents = (
  employeePrivileges: BaseDataResponseBody["businessUser"]["privileges"],
  businessUserEmail: string,
): boolean => {
  if (!employeePrivileges) {
    return false;
  }

  if (!isTrustpilotEmployee(employeePrivileges, businessUserEmail)) {
    return false;
  }

  if (hasOnlyOverviewPrivilege(employeePrivileges)) {
    return false;
  }

  if (hasElevatedEditPrivilege(employeePrivileges, businessUserEmail)) {
    return false;
  }

  return true;
};

export const exportEmployeePermissionsFunctionsForTesting = {
  hasOnlyOverviewPrivilege,
  hasEditPrivilege,
  hasElevatedEditPrivilege,
};
